/* global modForm */
import { parseHTMLFromString } from '../../../helpers';

/**
 * Handles mouse leave events to trigger abandonment popup when user moves cursor above viewport.
 * @see {@link modForm.abandonmentTriggerCallback} in modform.abandonment.jsdocs.js for full type definition
 * @param {MouseEvent} e - Mouse leave event from document.body
 * @returns {false|void} Returns `false` when prevented, otherwise no return value
 */
export const abandonmentTriggerCallback = function(e) {
	const mouseY = e.clientY;

	if (modForm.isSubmitting || modForm.opts.form.classList.contains(modForm.opts.formSubmittedCls) || document.body.classList.contains('prevent-abandonment')) {
		document.body.removeEventListener('mouseleave', abandonmentTriggerCallback);
		return false;
	}

	if (mouseY < 50 && document.querySelector('#abandonment:empty')) {
		// Don't show abandonment if form submission has started
		document.body.classList.add('no-scroll');
		// Load Abadonment Popup Content
		const url = 'abandonment/index.html';
		fetch(url).then((response) => response.text()).then(function(htmlString) {
			const parsedHtml = parseHTMLFromString(htmlString);
			document.querySelector('#abandonment').appendChild(parsedHtml);
		});
		document.body.removeEventListener('mouseleave', abandonmentTriggerCallback);
	}
};
